import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import App from './App';
import { DEPLOYMENT_CONFIG } from './config/deployment';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Get the basename from the deployment configuration
const getBasename = () => {
  return DEPLOYMENT_CONFIG.getCurrentPath();
};

root.render(
  <React.StrictMode>
    <BrowserRouter basename={getBasename()}>
      <App />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  </React.StrictMode>
);
